import React from "react";

/* eslint-disable max-len */
export default function RedRightArrowIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 21.2 21.2" enableBackground="new 0 0 21.2 21.2" xmlSpace="preserve">
		<g>
			<rect fill="none" width="21.2" height="21.2"/>
			<g>
				<polygon fill="#D1161B" points="5.5,17.8 7.1,19.4 15.9,10.6 7.1,1.8 5.5,3.3 12.8,10.6 		"/>
			</g>
		</g>
		</svg>
    );
}
